<template>
    <el-row class="pageSize" style="margin: 0 auto; padding-top: 15px" v-loading="loading">
        <el-row>
            <el-row>
                <el-col :span="1" class="el-tabs__item" style="height: 30px">
                </el-col>
                <el-col :span="14" class="suitability_home left_text_align" @click.native="backHome"
                    style="cursor: pointer"><i class="el-icon-s-home"></i>返回主页菜单
                    <div class="imgs_logo" />
                </el-col>
                <el-col :span="9" @click.native="logoutAccount" class="suitability_home right_text_align"
                    style="cursor: pointer">
                    <span class="font_title_email">{{ account }}</span><span>[退出]</span>
                </el-col>
            </el-row>
            <el-row class="padding_30px_bottom padding_10px_top">
                <el-col :span="1" class="el-tabs__item el-tabs__item"> </el-col>
                <el-col :span="5" class="suitability_home_title left_text_align">基金公司分析</el-col>
                <el-col :span="12" class="suitability_home_title right_text_align" style="
                        display: inline-block;
                        text-align: right;
                        margin-left: 350px;
                        float: right;
                    ">

                    <el-date-picker v-model="dateValueMonthly" align="right" type="month" :clearable="false"
                        placeholder="查看历史数据" value-format="yyyy-MM" style="padding-right：10px;width: 140px !important"
                        :picker-options="pickerOptionsMonthly" v-show="showDailylyRankingDate"
                        @change="changeMonthlyDate">
                    </el-date-picker>

                    <!-- <el-date-picker
            v-model="dateValueMonthly"
            align="right"
            type="month"
            :clearable="false"
            placeholder="查看历史数据"
            value-format="yyyy-MM"
            style="width: 140px !important"
            :picker-options="pickerOptionsMonthly"
            v-show="showMonthlyRankingDate"
            @change="changeMonthlyDate"
          >
          </el-date-picker> -->

                    <!--el-button
            icon="icon_export"
            @click="downloadFile()"
            :disabled="disableExport"
            style="width:140px !important;"
          >导出EXCEL</el-button-->

                    <el-popover placement="bottom" width="100" trigger="click" v-model="exportVisible"
                        popper-class="ranking-exportExcel">
                        <!-- <ul>
              <el-button
                type="text"
                @click="onceSendDialogVisible=true"
              >立即导出</el-button>
            </ul> -->
                        <el-button slot="reference" icon="icon_export" @click="exportList()">导出数据</el-button>
                    </el-popover>

                </el-col>
            </el-row>
        </el-row>
        <el-row>
            <el-dialog width="250px" :visible.sync="onceSendDialogVisible" center :modal-append-to-body="false"
                :show-close="false" custom-class="customDialog">
                <p style="text-align: center; font-weight: bold">
                    导出EXCEL文件
                </p>
                <el-select v-model="exportOption" placeholder="请选择">
                    <el-option label="当前列表" value="currentList">
                    </el-option>
                </el-select>
                <div style="text-align: center; margin-top: 15px">
                    <el-button size="mini" round @click="onceSendDialogVisible = false">取消</el-button>
                    <el-button type="primary" size="mini" @click="exportList()" round>导出</el-button>
                </div>
            </el-dialog>
            <el-dialog :visible.sync="configSendDialogVisible" width="525px" center :modal-append-to-body="false"
                :show-close="false" custom-class="customDialog">
                <el-row v-loading="dialogLoading">
                    <el-col :span="1" class="height_1px"></el-col>
                    <el-col :span="23">
                        <el-row>
                            <el-col class="dialog_title">设置发送条件</el-col>
                        </el-row>
                        <br />
                        <el-row>
                            <el-col :span="8" class="dialog_font">发送频率</el-col>
                            <el-col :span="15">
                                <el-select v-if="showDailylyRankingDate" v-model="selectFrequencyDaily"
                                    class="frequency_input">
                                    <el-option value="daily" label="每日">
                                    </el-option>
                                    <el-option value="weekly" label="每周">
                                    </el-option>
                                    <el-option value="monthly" label="每月">
                                    </el-option>
                                </el-select>
                                <el-select v-if="showMonthlyRankingDate" v-model="selectFrequencyMonthly"
                                    class="frequency_input">
                                    <el-option value="monthly" label="每月">
                                    </el-option>
                                </el-select>
                            </el-col>
                        </el-row>
                        <br />
                        <el-row>
                            <el-col :span="8" class="dialog_font" style="line-height: 244px;">发送邮箱</el-col>
                            <el-col :span="16" style="width: 253px;">
                                <el-col style="
                                            border-radius: 0px;
                                            width: 300px;
                                            border: 1px solid #c0c4cc;
                                            height: 244px;
                                        ">
                                    <el-scrollbar ref="scrollbar" style="height: 100%;">
                                        <el-col v-for="item in emailsParagraph" :key="item.index" :span="24"
                                            class="padding_4px">
                                            <el-tag type="info" closable @close="
                                                handleRemoveEmail(item)
                                                ">{{ item }}</el-tag>
                                        </el-col>
                                    </el-scrollbar>
                                </el-col>
                            </el-col>
                        </el-row>
                        <br />
                        <el-row>
                            <el-col :span="8" class="dialog_font">添加发送邮箱</el-col>
                            <el-col :span="16">
                                <el-input placeholder="请输入内容" v-model="emailInput" class="input-with-select"
                                    @keyup.enter.native="
                                        handleAddEmail(emailInput)
                                        ">
                                    <el-button slot="append" @click="handleAddEmail(emailInput)"
                                        :disabled="disableExport">添加</el-button>
                                </el-input>
                            </el-col>
                        </el-row>
                        <br />
                        <el-row>
                            <el-col :span="14">
                                <el-button size="small" class="button_space" round @click="
                                    sendRankReport()
                                    " :disabled="disableExport">立即发送</el-button>
                            </el-col>
                            <el-col :span="4" class="right_text_align" style="padding-right: 85px;">
                                <el-button size="small" class="button_space" round
                                    @click="configSendDialogVisible = false">取 消</el-button>
                            </el-col>
                            <el-col :span="4" class="right_text_align padding_20px_left">
                                <el-button size="small" class="button_space" type="primary" round
                                    @click="savaSubscritionInfo">保 存</el-button>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </el-dialog>
        </el-row>

        <el-row v-show="isShowRankingTab" style="">
            <el-col :span="1" class="line_border_bottom el-tabs__item">
            </el-col>
            <el-col :span="23">
                <el-tabs v-model="activeName" type="card">
                    <el-tab-pane label="评分细项" name="first" style="margin-top: 10px;">
                        <span
                            style="margin-top: 8px;position: absolute;left:0px;top:-10px;font-weight: bold;font-size: small;">数据展示(支持多选)
                            :</span>
                        <div class="tableTitle"><span class="midText"></span></div>

                        <el-select v-model="company" v-show="!isShowCompanySelect" filterable
                            placeholder="请选择或输入公司首拼、关键字" :filter-method="fiterCompany" clearable
                            style="width: 230px !important;float: right;margin-top: -10px;" id="elselectCompany">
                            <el-option v-for="item in filteredCompanyList" :key="item.companyName"
                                :label="item.companyName" :value="item.companyId">
                            </el-option>
                        </el-select>
                        <el-popover placement="bottom"
                            style="width: 230px !important;margin-left: 1000px;margin-top: -15px;"
                            v-show="isShowCompanySelect" v-model="searchPopoverVisible">
                            <el-row style="width: 380px; height: 300px" v-loading="loading2">
                                <el-scrollbar ref="search_scrollbar" style="height: 100%">
                                    <el-row style="
                                        text-align: left;
                                        margin: 0;
                                        font-size: 12px;
                                        cursor: pointer;
                                    " v-for="(node, index) in state" class="fundInformation" :key="index">
                                        <el-col :span="24" v-html="node" @click.native="getFundInformation(node)"
                                            :ref="'cssClass' + index" @mouseenter.native="
                                                changeClass($event, index)
                                                " :class="{ searchHover: 1 === index }"></el-col>
                                    </el-row>
                                </el-scrollbar>
                            </el-row>
                            <el-input v-model="symbolInfo" slot="reference" placeholder="请输入基金代码或基金名称" type="text"
                                suffix-icon="el-icon-search" @input="searchFundCache(symbolInfo)"
                                @keyup.enter.native="submitSearch"
                                style="width: 230px !important;margin-left: 1000px;margin-top: -15px;"
                                id="elselectFund"></el-input>
                        </el-popover>


                        <CompanyEvaluateOpenExcludeQDII ref="companyevaluateOpenExcludeQDII" :latestRatio="rankingRatio"
                            @changeRankingRatio="setRankingRatio" v-show="showDailylyRankingDate">
                        </CompanyEvaluateOpenExcludeQDII>
                        <!-- <CompanyEvaluateOpenExcludeQDIIMonthly
              ref="companyevaluateOpenExcludeQDIIMonthly"
              :latestRatio="rankingRatio"
              @changeRankingRatio="setRankingRatio"
              v-show="!showDailylyRankingDate"
            ></CompanyEvaluateOpenExcludeQDIIMonthly> -->
                    </el-tab-pane>
                </el-tabs>
            </el-col>
        </el-row>
        <el-raw v-show="!isShowRankingTab">
            <CompanyEvaluateSearch ref="companyevaluateSearch" v-show="showDailylyRankingDate"></CompanyEvaluateSearch>
            <CompanyEvaluateSearchMonthly ref="companyevaluateSearchMonthly" v-show="!showDailylyRankingDate">
            </CompanyEvaluateSearchMonthly>
        </el-raw>
        <br />
    </el-row>
</template>
<script>
import { Message } from "element-ui";
import {
    rankDownload,
    getFundRank,
    getCompanyEvaluate,
    getExport,
    getMonthlyReportFixed
} from "../api/ranking";
import CompanyEvaluateOpenExcludeQDII from "./CompanyEvaluateOpenExcludeQDII";
import CompanyEvaluateClose from "./CompanyEvaluateClose";
import CompanyEvaluateSearch from "./CompanyEvaluateSearch";
import XLSX from "xlsx";
import CompanyEvaluateOpenExcludeQDIIMonthly from "./CompanyEvaluateOpenExcludeQDIIMonthly";
import CompanyEvaluateCloseMonthly from "./CompanyEvaluateCloseMonthly";
import CompanyEvaluateSearchMonthly from "./CompanyEvaluateSearchMonthly";

const componentsCommon = require("cb-components-common").default;
const checkResponseStatus = componentsCommon.common.checkResponseStatus;
const logout = componentsCommon.common.logout;
const getDisableExport = componentsCommon.common.getDisableExport;
const getRankingMemberBaseTrial = componentsCommon.common.getRankingMemberBaseTrial;
const getRankingMemberBase = componentsCommon.common.getRankingMemberBase;
const getRankingMemberSeniorTrial = componentsCommon.common.getRankingMemberSeniorTrial;
const getRankingMemberSenior = componentsCommon.common.getRankingMemberSenior;
const getNameAndValue = componentsCommon.localStorage.getNameAndValue;
const fetchFile = componentsCommon.downloadUtils.fetchFile;
const openDownloadDialog = componentsCommon.downloadUtils.openDownloadDialog;
const sheet2blob4Rank = componentsCommon.downloadUtils.sheet2blob4Rank;
const getCompanyList = componentsCommon.apiCommon.getCompanyList;
const getLatestDate = componentsCommon.apiCommon.getLatestDate;
const getWorkDate = componentsCommon.apiCommon.getWorkDate;
const getFilter = componentsCommon.apiCommon.getFilter;
const searchBox = componentsCommon.mixin.searchBox.searchBox;
const exportFile = componentsCommon.mixin.exportFile.exportFile;
const getENV = componentsCommon.getENV;
const componentsSuitability = require("cb-components-suitability").default;
const frequencyConfig =
    componentsSuitability.Suitability.components.LatestEvaluation.mixins[2];

export default {
    mixins: [exportFile, searchBox, CompanyEvaluateSearch, frequencyConfig],
    data() {
        return {
            configResendNeeded: true,
            selectFrequencyDaily: "daily",
            selectFrequencyMonthly: "monthly",
            configSendDialogVisible: false,
            onceSendDialogVisible: false,
            exportOption: "currentList",
            exportVisible: false,
            rankingRatio: "",
            isShowRankingTab: true,
            searchPopoverVisible: false,
            symbolList: [],
            isShowCompanySelect: false,
            searchTypeSel: "",
            symbolInfo: "",
            symbol: [],
            activeName: "first",
            account: "",
            company: "",
            companyList: [],
            filteredCompanyList: [],
            loading: false,
            dateValue: "",
            dateValueMonthly: "",
            disableExport: true,
            rankingType: "monthlyRanking",
            disableDailyRanking: true,
            disableMonthlyRanking: true,
            showDailylyRankingDate: false,
            showMonthlyRankingDate: true,
            monthlySignOff: false,
            monthlyLastUpdate: "",
            pickerOptions: {
                disabledDate(time) {
                    if (window.availableWorkDate) {
                        let year = time.getFullYear();
                        let month = time.getMonth() + 1;
                        let day = time.getDate();
                        let originDate =
                            year +
                            (month < 10 ? "-0" : "-") +
                            month +
                            (day < 10 ? "-0" : "-") +
                            day;
                        return (
                            window.availableWorkDate.indexOf(originDate) === -1
                        );
                    }
                    return false;
                },
                cellClassName(time) {
                    if (window.latestWorkDate) {
                        let tempDate = window.latestWorkDate.split("-");
                        let tempLatestWorkDate = new Date(
                            tempDate[0],
                            tempDate[1],
                            tempDate[2]
                        );
                        let tempMonth = time.getMonth();
                        if (tempMonth == 12) {
                            tempMonth = 1;
                        } else {
                            tempMonth = tempMonth + 1;
                        }

                        if (
                            tempLatestWorkDate.getFullYear() ==
                            time.getFullYear() &&
                            tempLatestWorkDate.getMonth() == tempMonth &&
                            tempLatestWorkDate.getDate() == time.getDate()
                        ) {
                            return "red";
                        }
                    }
                }
            },
            pickerOptionsMonthly: {
                disabledDate(time) {
                    let timeNow = new Date();
                    return (
                        time.getTime() > Date.now() - 8.64e7 || //remove future date
                        (time.getFullYear() == timeNow.getFullYear() &&
                            time.getMonth() == timeNow.getMonth() ||
                            time.getMonth() == 0 ||
                            time.getMonth() == 1 ||
                            time.getMonth() == 3 ||
                            time.getMonth() == 4 ||
                            time.getMonth() == 6 ||
                            time.getMonth() == 7 ||
                            time.getMonth() == 9 ||
                            time.getMonth() == 10)  //remove current month
                        // (time.getFullYear() < timeNow.getFullYear() && //remove year which less than current year and only keep quarter month
                        //     (time.getMonth() == 0 ||
                        //         time.getMonth() == 1 ||
                        //         time.getMonth() == 2 ||
                        //         time.getMonth() == 3 ||
                        //         time.getMonth() == 4 ||
                        //         time.getMonth() == 5 ||
                        //         time.getMonth() == 6 ||
                        //         time.getMonth() == 7 ||
                        //         time.getMonth() == 8 ||
                        //         time.getMonth() == 9 ||
                        //         time.getMonth() == 10 ||
                        //         time.getMonth() == 11 ))
                    );
                }
            }
        };
    },
    watch: {
        activeName: function (val) {
            let self = this;
            this.reloadPage();
        },
        dateValue: function (val) {
            let self = this;
            this.reloadPage();
        },
        dateValueMonthly: function (val) {
            let self = this;
            if (val == null || val == "" || val == undefined) {
                self.setDateValueMonthlyToLastMonthendDateWhenItIsNull();
            }
            this.reloadPage();
        },
        company: function (val) {
            let self = this;
            this.reloadPage();
        },
        rankingType: function (val) {
            let self = this;
            let userInfo = getNameAndValue("info");
            if (userInfo != undefined && userInfo != null && userInfo != "") {
                const user = JSON.parse(userInfo);
                if (val == "dailyRanking") {
                    self.showDailylyRankingDate = true;
                    self.showMonthlyRankingDate = false;

                    if (user.rankingMemberSeniorTrial) {
                        // self.disableExport = getDisableExport()||getRankingMemberSeniorTrial();
                        if (getDisableExport() || user.rankingMemberSeniorTrial) {
                            self.disableExport = true;
                        }
                        else {
                            self.disableExport = false;
                        }
                    }
                    else {
                        self.disableExport = getDisableExport();
                    }
                } else {
                    self.showDailylyRankingDate = false;
                    self.showMonthlyRankingDate = true;

                    self.setDateValueMonthlyToLastMonthendDateWhenItIsNull();

                    if (user.rankingMemberBaseTrial) {
                        // self.disableExport = getDisableExport()||getRankingMemberBaseTrial();
                        if (getDisableExport() || user.rankingMemberBaseTrial) {
                            self.disableExport = true;
                        }
                        else {
                            self.disableExport = false;
                        }
                    }
                    else {
                        self.disableExport = getDisableExport();
                    }
                }
            }

            self.reloadPage();
        }
    },
    components: {
        CompanyEvaluateOpenExcludeQDII,
        CompanyEvaluateClose,
        CompanyEvaluateSearch,
        CompanyEvaluateOpenExcludeQDIIMonthly,
        CompanyEvaluateCloseMonthly,
        CompanyEvaluateSearchMonthly
    },
    mounted() {
        let self = this;
        let userInfo = getNameAndValue("info");
        if (userInfo != undefined && userInfo != null && userInfo != "") {
            const user = JSON.parse(userInfo);
            self.account = user.email;

            self.showDailylyRankingDate = true;
            if (user.ranking == 1) {

                if ((user.rankingMemberBaseTrial || user.rankingMemberBase) && !user.rankingMemberSeniorTrial && !user.rankingMemberSenior) {
                    self.rankingType = "monthlyRanking";
                    self.disableDailyRanking = true;
                    self.disableMonthlyRanking = false;

                    // self.showDailylyRankingDate = false;
                    self.showMonthlyRankingDate = true;

                    if (user.rankingMemberBaseTrial) {
                        if (getDisableExport() || user.rankingMemberBaseTrial) {
                            this.disableExport = true;
                        }
                        else {
                            this.disableExport = false;
                        }
                    }
                    else {
                        this.disableExport = getDisableExport();
                    }
                }

                if (!user.rankingMemberBaseTrial && !user.rankingMemberBase && (user.rankingMemberSeniorTrial || user.rankingMemberSenior)) {
                    self.rankingType = "dailyRanking";

                    self.disableDailyRanking = false;
                    self.disableMonthlyRanking = true;

                    self.showDailylyRankingDate = true;
                    self.showMonthlyRankingDate = false;

                    if (user.rankingMemberSeniorTrial) {
                        if (getDisableExport() || user.rankingMemberSeniorTrial) {
                            this.disableExport = true;
                        }
                        else {
                            this.disableExport = false;
                        }
                    }
                    else {
                        this.disableExport = getDisableExport();
                    }
                }

                if ((user.rankingMemberBaseTrial || user.rankingMemberBase) && (user.rankingMemberSeniorTrial || user.rankingMemberSenior)) {
                    self.rankingType = "dailyRanking";
                    self.disableDailyRanking = false;
                    self.disableMonthlyRanking = false;
                    self.showDailylyRankingDate = true;
                    self.showMonthlyRankingDate = false;

                    if (user.rankingMemberSeniorTrial) {
                        if (getDisableExport() || user.rankingMemberSeniorTrial) {
                            this.disableExport = true;
                        }
                        else {
                            this.disableExport = false;
                        }
                    }
                    else {
                        this.disableExport = getDisableExport();
                    }
                }
            }
        } else {
            logout(self);
        }

        if (self.activeName == "first") {
            self.handleLatestDate();
            if (self.showDailylyRankingDate) {
                self.$refs.companyevaluateOpenExcludeQDII.loadingData(
                    "EquityFunds",
                    self.company,
                    self.showDailylyRankingDate
                        ? self.dateValue
                        : self.dateValueMonthly
                );
            } else {
                self.$refs.companyevaluateOpenExcludeQDIIMonthly.loadingData(
                    "EquityFunds",
                    self.company,
                    self.showDailylyRankingDate
                        ? self.dateValue
                        : self.dateValueMonthly
                );
            }
            if (
                this.dateValueMonthly == null ||
                this.dateValueMonthly == "" ||
                this.dateValueMonthly == undefined
            ) {
                let newDate = new Date();
                let lastMonthEndDate = new Date(
                    newDate.getFullYear(),
                    newDate.getMonth(),
                    0
                );
                //this.dateValueMonthly = lastMonthEndDate.getFullYear() +"-"+(lastMonthEndDate.getMonth() + 1).toString().padStart(2,'0')+"-"+lastMonthEndDate.getDate();
                // this.dateValueMonthly =
                //     lastMonthEndDate.getFullYear() +
                //     "-" +
                //     (lastMonthEndDate.getMonth()+1)
                //         .toString()
                //         .padStart(2, "0");
            }
        }

        self.handleCompany();
        self.getWorkDateFun({ limit: 5, skip: 0 });
    },
    methods: {
        submitSearch() {
            let self = this;
            self.reloadPage();
        },
        setRankingRatio(value) {
            let self = this;
            self.rankingRatio = value;
        },
        searchDataByAutoComplete(queryString, that) {
            const self = this;
            let results = self.symbolList;
            self.state.length = 0;
            self.state.push(
                "<span class='searchbox_symbol font_bold'>基金代码</span><span class='searchbox_title font_bold'>基金名称</span>"
            );
            if (results !== undefined) {
                for (let i = 0; i < results.length; i++) {
                    const value = results[i].symbol + "    " + results[i].name;
                    let htmlString = value.replace(
                        queryString,
                        "<b style='color:red;'>" + queryString + "</b>"
                    );
                    htmlString = htmlString.replace(
                        "    ",
                        "</span><span class='searchbox_title'>"
                    );
                    if (i === 0) {
                        self.firstSymbol = results[i].symbol;
                        self.state.push(
                            "<span class='searchbox_symbol'>" +
                            htmlString +
                            "</span>"
                        );
                    } else {
                        self.state.push(
                            "<span class='searchbox_symbol'>" +
                            htmlString +
                            "</span>"
                        );
                    }
                }
            }
            if (results === undefined || results.length === 0) {
                self.state.length = 0;
                self.state.push(
                    "<span class='font_bold'>抱歉，没有找到和" +
                    "<b style='color:red;'>" +
                    queryString +
                    "</b>" +
                    "相关的内容</span>"
                );
            }
            self.$refs.search_scrollbar.update();
            //self.$refs.searchPopover.updatePopper();
        },
        getFundInformation(symbolValue) {
            let self = this;
            let symbolInfo = [];
            if (
                symbolValue.indexOf("</span><span class='searchbox_title'>") >
                -1
            ) {
                self.searchPopoverVisible = false;
                symbolInfo = symbolValue.split(
                    "</span><span class='searchbox_title'>"
                );

                symbolValue = symbolInfo[0];
                symbolValue = symbolValue
                    .replace("<b style='color:red;'>", "")
                    .replace("<span class='searchbox_symbol'>", "")
                    .replace("</b>", "");
            }

            if (!isNaN(Number(symbolValue))) {
                let symbolName = symbolInfo[1]
                    .replace("</span>", "")
                    .replace("<b style='color:red;'>", "")
                    .replace("</b>", "");
                self.symbolInfo = symbolValue + " " + symbolName;
                self.symbol = new Array();
                self.symbol[0] = symbolValue;
                self.symbol[1] = symbolName;
                self.isShowRankingTab = false;
                if (self.showDailylyRankingDate) {
                    self.$refs.companyevaluateSearchMonthly.loadingData(
                        "",
                        self.company,
                        self.showDailylyRankingDate
                            ? self.dateValue
                            : self.dateValueMonthly,
                        self.isShowRankingTab,
                        symbolValue + "_" + symbolName
                    );
                } else {
                    self.$refs.companyevaluateSearchMonthly.loadingData(
                        "",
                        self.company,
                        self.showDailylyRankingDate
                            ? self.dateValue
                            : self.dateValueMonthly,
                        self.isShowRankingTab,
                        symbolValue + "_" + symbolName
                    );
                }
            }
        },
        selectFundOrCompany(value) {
            let self = this;
            if (value === "selectCompany") {
                self.isShowCompanySelect = true;
                self.searchPopoverVisible = false;
                self.symbolInfo = "";
                self.activeName = "";
            }
            if (value === "selectFund") {
                self.isShowCompanySelect = false;
                self.company = "";
                self.activeName = "";
            }
            if (value === "") {
                self.activeName = "first";
                self.company = "";
                self.symbolInfo = "";
                self.searchTypeSel = "";
                self.symbol = "";
                self.isShowRankingTab = true;
            }
        },
        logoutAccount() {
            let self = this;
            logout(self);
        },
        backHome() {
            let self = this;
            self.$router.push({
                path: "/home"
            });
            // self.$router.go(-1);
        },
        latestReload(para) {
            let self = this;
            if (para.name == "first") {
                if (self.showDailylyRankingDate) {
                    self.$refs.companyevaluateOpenExcludeQDIIMonthly.loadingData(
                        "EquityFunds",
                        self.company,
                        self.showDailylyRankingDate
                            ? self.dateValue
                            : self.dateValueMonthly
                    );
                } else {
                    self.$refs.companyevaluateOpenExcludeQDIIMonthly.loadingData(
                        "EquityFunds",
                        self.company,
                        self.showDailylyRankingDate
                            ? self.dateValue
                            : self.dateValueMonthly
                    );
                }
            }
        },
        handleLatestDate() {
            const self = this;
            getLatestDate()
                .then(response => {
                    let result = response.data;
                    if (result == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000
                        });
                        Message.close = function () { };
                    } else {
                        if (checkResponseStatus(result, self)) {
                            if (
                                Number(result._meta.response_status) === 200032
                            ) {
                                Message({
                                    message:
                                        "非常抱歉，数据正在更新中，请稍后再试！",
                                    type: "warning",
                                    duration: 3 * 1000
                                });
                                Message.close = function () { };
                            } else {
                                self.dateValueMonthly = result.data.date;
                            }
                        }
                    }
                })
                .catch(err => {
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000
                    });
                    Message.close = function () { };
                })
                .finally(r => {
                    self.loading = false;
                });
        },
        handleCompany() {
            const self = this;
            getCompanyList()
                .then(response => {
                    let result = response.data;
                    if (result == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000
                        });
                        Message.close = function () { };
                    } else {
                        if (checkResponseStatus(result, self)) {
                            if (
                                Number(result._meta.response_status) === 200032
                            ) {
                                Message({
                                    message:
                                        "非常抱歉，数据正在更新中，请稍后再试！",
                                    type: "warning",
                                    duration: 3 * 1000
                                });
                                Message.close = function () { };
                            } else {
                                self.companyList = self.filteredCompanyList =
                                    result.data.companyList;
                            }
                        }
                    }
                })
                .catch(err => {
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000
                    });
                    Message.close = function () { };
                })
                .finally(r => {
                    self.loading = false;
                });
        },
        fiterCompany(query) {
            if (query !== "") {
                this.filteredCompanyList = this.companyList.filter(item => {
                    return (
                        (item.companyNamePhonetic != null && item.companyName != null)
                        &&
                        (item.companyNamePhonetic
                            .toLowerCase()
                            .indexOf(query.toLowerCase()) > -1 ||
                            item.companyName.indexOf(query) > -1)
                    );
                });
            } else {
                this.filteredCompanyList = this.companyList;
            }
        },
        reloadPage() {
            let self = this;
            let keyword = "";
            if (self.symbol.indexOf("_") > -1) {
                keyword = self.symbol[0] + "_" + self.symbol[1];
            } else {
                keyword = self.symbolInfo;
            }

            if (self.showDailylyRankingDate) {
                switch (self.activeName) {
                    case "first":
                        self.$refs.companyevaluateOpenExcludeQDII.loadingData(
                            "EquityFunds",
                            self.company,
                            self.showDailylyRankingDate
                                ? self.dateValueMonthly
                                : self.dateValueMonthly
                        );
                        break;
                    case "second":
                        self.$refs.companyevaluateClose.loadingData(
                            "EquityFunds",
                            self.company,
                            self.showDailylyRankingDate
                                ? self.dateValue
                                : self.dateValueMonthly
                        );
                        break;
                    default:
                        self.isShowRankingTab = false;
                        self.$refs.companyevaluateSearch.loadingData(
                            "",
                            self.company,
                            self.showDailylyRankingDate
                                ? self.dateValue
                                : self.dateValueMonthly,
                            self.isShowRankingTab,
                            keyword
                        );
                        break;
                }
            } else {
                switch (self.activeName) {
                    case "first":
                        self.$refs.companyevaluateOpenExcludeQDIIMonthly.loadingData(
                            "EquityFunds",
                            self.company,
                            self.showDailylyRankingDate
                                ? self.dateValue
                                : self.dateValueMonthly
                        );
                        break;
                    case "second":
                        self.$refs.companyevaluateCloseMonthly.loadingData(
                            "EquityFunds",
                            self.company,
                            self.showDailylyRankingDate
                                ? self.dateValue
                                : self.dateValueMonthly
                        );
                        break;
                    default:
                        self.isShowRankingTab = false;
                        self.$refs.companyevaluateSearchMonthly.loadingData(
                            "",
                            self.company,
                            self.showDailylyRankingDate
                                ? self.dateValue
                                : self.dateValueMonthly,
                            self.isShowRankingTab,
                            keyword
                        );
                        break;
                }
            }
        },
        downloadFile() {
            let self = this;
            let name = "";
            let tempType = "";
            switch (self.activeName) {
                case "first":
                    name = "晨星中国开放式及ETF基金排行榜";
                    tempType = "openEnd";
                    break;
                case "second":
                    name = "晨星中国封闭式基金业绩报告";
                    tempType = "closeEnd";
                    break;
                case "third":
                    name = "晨星中国QDII及海外基金排行榜";
                    tempType = "qDII";
                    break;
                default:
                    name = "晨星中国开放式及ETF基金排行榜";
                    tempType = "openEnd";
                    break;
            }
            let data = {
                type: tempType,
                date: self.dateValue
            };

            let fileName = name + ".xlsx";
            let fileType = "application/octet-stream;charset=utf-8";
            self.loading = true;
            rankDownload(data)
                .then(response => {
                    let data = response.data;
                    if (response.status == 200) {
                        fetchFile(data, fileType, fileName);
                    }
                    self.loading = false;
                })
                .catch(err => {
                    self.loading = false;
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000
                    });
                    Message.close = function () { };
                })
                .finally(r => {
                    self.loading = false;
                });
        },
        exportList() {
            let self = this;
            self.exportVisible = true;
            let data = {
                id: getNameAndValue("id"),
                date: self.dateValueMonthly
            };
            getExport(data).then(res => {
                // window.location.href = "http://localhost:8014/v1/funds/select/export?indexId=" + res.data.data.indexId;
                // window.location.href = "https://chinabusinessapi.morningstar.cn/suitability/v1/funds/select/export?indexId=" + res.data.data.indexId;
                const env = getENV();
                window.open(`${env.EXPORT_API}/suitability/v1/funds/select/export?indexId=` + res.data.data.indexId);
            }).catch(err => {
                self.loading = false;
                Message({
                    message: "数据异常，请尝试刷新再试！",
                    type: "error",
                    duration: 2 * 1000
                });
                Message.close = function () { };
            })
                .finally(r => {
                    self.loading = false;
                });

            // window.location.href="https://chinabusinessapi.morningstar.cn/v1/funds/select/export";

            // let params = {};
            // let fileName = "";
            // if (self.showDailylyRankingDate) {
            //     if (self.exportOption == "currentList") {
            //         fileName = "当前列表";
            //         switch (self.activeName) {
            //             case "first":
            //                 params = self.$refs.companyevaluateOpenExcludeQDII.params;
            //                 params.limit =
            //                     self.$refs.companyevaluateOpenExcludeQDII.pagination.count;
            //                 break;
            //             case "second":
            //                 params = self.$refs.companyevaluateClose.params;
            //                 params.limit =
            //                     self.$refs.companyevaluateClose.pagination.count;
            //                 break;
            //             default:
            //                 params = self.$refs.companyevaluateSearch.params;
            //                 params.limit =
            //                     self.$refs.companyevaluateSearch.pagination.count;
            //                 break;
            //         }
            //     } else {
            //         fileName = "所有基金列表（日榜）";
            //         params = {
            //             type: "",
            //             category: "", //"EquityFunds",
            //             keyword: "",
            //             date: self.dateValueMonthly, //"2020-06-30",
            //             month: "", //"2020-06-30",
            //             quarter: "", //"2020-06-30",
            //             sort: "classcount",
            //             order: "desc",
            //             limit: 99999,
            //             skip: 0,
            //             page: 1
            //         };
            //     }
            // } else {
            //     if (self.exportOption == "currentList") {
            //         fileName = "当前列表（月榜）";
            //         switch (self.activeName) {
            //             case "first":
            //                 params =
            //                     self.$refs.companyevaluateOpenExcludeQDIIMonthly.params;
            //                 params.limit =
            //                     self.$refs.companyevaluateOpenExcludeQDIIMonthly.pagination.count;
            //                 break;
            //             case "second":
            //                 params = self.$refs.companyevaluateCloseMonthly.params;
            //                 params.limit =
            //                     self.$refs.companyevaluateCloseMonthly.pagination.count;
            //                 break;
            //             default:
            //                 params = self.$refs.companyevaluateSearchMonthly.params;
            //                 params.limit =
            //                     self.$refs.companyevaluateSearchMonthly.pagination.count;
            //                 break;
            //         }
            //     } else {
            //         fileName = "所有基金列表（月榜）";
            //         params = {
            //             type: "",
            //             category: "", //"EquityFunds",
            //             keyword: "",
            //             date: self.dateValueMonthly, //"2020-06-30",
            //             month: "", //"2020-06-30",
            //             quarter: "", //"2020-06-30",
            //             sort: "classcount",
            //             order: "desc",
            //             limit: 99999,
            //             skip: 0,
            //             page: 1
            //         };
            //     }
            // }
            // self.loading = true;
            // getCompanyEvaluate(params)
            //     .then(response => {
            //         let result = response.data;
            //         if (result == undefined) {
            //             Message({
            //                 message: "数据异常，请尝试刷新再试！",
            //                 type: "error",
            //                 duration: 2 * 1000
            //             });
            //             Message.close = function() {};
            //         } else {
            //             if (checkResponseStatus(result, self)) {
            //                 if (
            //                     Number(result._meta.response_status) === 200032
            //                 ) {
            //                     Message({
            //                         message:
            //                             "非常抱歉，数据正在更新中，请稍后再试！",
            //                         type: "warning",
            //                         duration: 3 * 1000
            //                     });
            //                     Message.close = function() {};
            //                 } else {
            //                     let selectList = result.data.selectInfo;
            //                     var exportData;
            //                     if (self.showDailylyRankingDate) {
            //                         exportData = [
            //                             [
            //         "基金公司名称",
            //         "参评基金数量(全部)",
            //         "总分值(全部)",
            //         "规模分类(全部)",
            //         "排名(全部)",
            //         "参评基金数量(偏股)",
            //         "总分值(偏股)",
            //         "规模分类(偏股)",
            //         "排名(偏股)",
            //         "参评基金数量(固收))",
            //         "总分值(固收)",
            //         "规模分类(固收)",
            //         "排名(固收)",
            //         "规模-不含货币基金(亿元)",
            //         "排名",
            //         "份额数量",
            //         "排名",
            //         "最近一年资金流(亿元)",
            //         "排名",
            //         "最近一年资金流增长率",
            //         "排名",
            //         "最近三年资金流(亿元)",
            //         "排名",
            //         "最近三年资金流增长率",
            //         "排名",
            //         "股票(亿元)",
            //         "排名",
            //         "混合(亿元)",
            //         "排名",
            //         "固收(亿元)",
            //         "排名",
            //         "货币(亿元)",
            //         "排名",
            //         "其它(亿元)",
            //         "一星基金规模占比",
            //         "二星基金规模占比",
            //         "三星基金规模占比",
            //         "四星基金规模占比",
            //         "五星基金规模占比",
            //         "加权星级",
            //         "基金经理人数",
            //         "排名",
            //         "基金经理平均投资管理年限",
            //         "排名",
            //         "基金经理平均在职时长",
            //         "排名",
            //         "最近三年留职率",
            //         "排名",
            //         "运营费率综合得分",
            //         "排名"
            //     ]
            // ];

            //                     for (let i = 0; i < selectList.length; i++) {
            //                             var row = [];
            //                             row.push(selectList[i].companyNameCN);
            //                             row.push(selectList[i].classCount);
            //                             row.push(selectList[i].companyScoreRaw);

            //                             if(selectList[i].sizeType == 1) {
            //                                 row.push("大型");
            //                             } else if (selectList[i].sizeType == 2) {
            //                                 row.push("中型");
            //                             } else if (selectList[i].sizeType == 3) {
            //                                 row.push("小型");
            //                             } else {
            //                                 row.push("");
            //                             }

            //                             if(selectList[i].sizeType == 1) {
            //                                 row.push(selectList[i].companyScoreRawRank+"/"+selectList[i].allBigSum);
            //                             } else if (selectList[i].sizeType == 2) {
            //                                 row.push(selectList[i].companyScoreRawRank+"/"+selectList[i].allMiddleSum);
            //                             } else if (selectList[i].sizeType == 3) {
            //                                 row.push(selectList[i].companyScoreRawRank+"/"+selectList[i].allSmallSum);
            //                             } else {
            //                                 row.push("");
            //                             }

            //                             row.push(selectList[i].eqallocclassCount);
            //                             row.push(selectList[i].eqalloccompanyScoreRaw);
            //                             if(selectList[i].eqallocsizeType == 1) {
            //                                 row.push("大型");
            //                             } else if (selectList[i].eqallocsizeType == 2) {
            //                                 row.push("中型");
            //                             } else if (selectList[i].eqallocsizeType == 3) {
            //                                 row.push("小型");
            //                             } else {
            //                                 row.push("");
            //                             }

            //                             if(selectList[i].eqallocsizeType == 1) {
            //                                 row.push(selectList[i].eqalloccompanyScoreRawRank+"/"+selectList[i].eqallocbigSum);
            //                             } else if (selectList[i].eqallocsizeType == 2) {
            //                                 row.push(selectList[i].eqalloccompanyScoreRawRank+"/"+selectList[i].eqallocmiddleSum);
            //                             } else if (selectList[i].eqallocsizeType == 3) {
            //                                 row.push(selectList[i].eqalloccompanyScoreRawRank+"/"+selectList[i].eqallocsmallSum);
            //                             } else {
            //                                 row.push("");
            //                             }

            //                             row.push(selectList[i].fxincclassCount);
            //                             row.push(selectList[i].fxinccompanyScoreRaw);
            //                             if(selectList[i].fxincsizeType == 1) {
            //                                 row.push("大型");
            //                             } else if (selectList[i].fxincsizeType == 2) {
            //                                 row.push("中型");
            //                             } else if (selectList[i].fxincsizeType == 3) {
            //                                 row.push("小型");
            //                             } else {
            //                                 row.push("");
            //                             }

            //                             if(selectList[i].fxincsizeType == 1) {
            //                                 row.push(selectList[i].fxinccompanyScoreRawRank+"/"+selectList[i].fxincbigSum);
            //                             } else if (selectList[i].fxincsizeType == 2) {
            //                                 row.push(selectList[i].fxinccompanyScoreRawRank+"/"+selectList[i].fxincmiddleSum);
            //                             } else if (selectList[i].fxincsizeType == 3) {
            //                                 row.push(selectList[i].fxinccompanyScoreRawRank+"/"+selectList[i].fxincsmallSum);
            //                             } else {
            //                                 row.push("");
            //                             }

            //                             row.push(selectList[i].fundSize);
            //                             row.push(selectList[i].fundSizeRank);
            //                             row.push(selectList[i].fundCount);
            //                             row.push(selectList[i].fundCountRank);
            //                             row.push(selectList[i].fundSizeFlow_1Y);
            //                             row.push(selectList[i].fundSizeFlowRank_1Y);
            //                             row.push(selectList[i].fundSizeFlowPer_1Y);
            //                             row.push(selectList[i].fundSizeFlowPerRank_1Y);
            //                             row.push(selectList[i].fundSizeFlow_3Y);
            //                             row.push(
            //                                 selectList[i].fundSizeFlowRank_3Y
            //                             );
            //                             row.push(selectList[i].fundSizeFlowPer_3Y);
            //                             row.push(
            //                                 selectList[i].fundSizeFlowPerRank_3Y
            //                             );
            //                             row.push(selectList[i].equity);
            //                             row.push(
            //                                 selectList[i].equityrank
            //                             );
            //                             row.push(selectList[i].alloc);
            //                             row.push(
            //                                 selectList[i].allocrank
            //                             );
            //                             row.push(selectList[i].fxinc);
            //                             row.push(
            //                                 selectList[i].fxincrank
            //                             );
            //                             row.push(selectList[i].mnmkt);
            //                             row.push(
            //                                 selectList[i].mnmktrank
            //                             );
            //                             row.push(
            //                                 selectList[i].other
            //                             );
            //                             row.push(selectList[i].star1Per+"%");
            //                             row.push(
            //                                 selectList[i].star2Per+"%"
            //                             );
            //                             row.push(
            //                                 selectList[i].star3Per+"%"
            //                             );
            //                             row.push(selectList[i].star4Per+"%");
            //                             row.push(
            //                                 selectList[i].star5Per+"%"
            //                             );
            //                             row.push(
            //                                 selectList[i].aumweightedStar
            //                             );
            //                             row.push(selectList[i].managerCount);
            //                             row.push(
            //                                 selectList[i].managerCountRank
            //                             );
            //                             row.push(
            //                                 parseFloat(selectList[i].managerCareerTime).toFixed(2)
            //                             );
            //                             row.push(selectList[i].managerCareerTimeRank);
            //                             row.push(
            //                                 parseFloat(selectList[i].managerStayTime).toFixed(2)
            //                             );
            //                             row.push(
            //                                 selectList[i].managerStayTimeRank
            //                             );
            //                             row.push(parseFloat(selectList[i].retention_3Y).toFixed(2)+"%");
            //                             row.push(
            //                                 selectList[i].retentionRank_3Y
            //                             );
            //                             row.push(
            //                                 selectList[i].terscore
            //                             );
            //                             row.push(
            //                                 selectList[i].terscoreRank
            //                             );
            //                             exportData.push(row);
            //                     }         
            //                 } else {
            //                     exportData = [
            //                         [
            //                             // "序号",
            //                             "基金公司名称",
            //                             "参评基金数量(全部)",
            //                             "总分值(全部)",
            //                             "规模分类(全部)",
            //                             "排名(全部)",
            //                             "参评基金数量(偏股)",
            //                             "总分值(偏股)",
            //                             "规模分类(偏股)",
            //                             "排名(偏股)",
            //                             "参评基金数量(固收))",
            //                             "总分值(固收)",
            //                             "规模分类(固收)",
            //                             "排名(固收)",
            //                             "规模-不含货币基金(亿元)",
            //                             "排名",
            //                             "份额数量",
            //                             "排名",
            //                             "最近一年资金流(亿元)",
            //                             "排名",
            //                             "最近一年资金流增长率",
            //                             "排名",
            //                             "最近三年资金流(亿元)",
            //                             "排名",
            //                             "最近三年资金流增长率",
            //                             "排名",
            //                             "股票(亿元)",
            //                             "排名",
            //                             "混合(亿元)",
            //                             "排名",
            //                             "固收(亿元)",
            //                             "排名",
            //                             "货币(亿元)",
            //                             "排名",
            //                             "其它(亿元)",
            //                             "一星基金规模占比",
            //                             "二星基金规模占比",
            //                             "三星基金规模占比",
            //                             "四星基金规模占比",
            //                             "五星基金规模占比",
            //                             "加权星级",
            //                             "基金经理人数",
            //                             "排名",
            //                             "基金经理平均投资管理年限",
            //                             "排名",
            //                             "基金经理平均在职时长",
            //                             "排名",
            //                             "最近三年留职率",
            //                             "排名",
            //                             "运营费率综合得分",
            //                             "排名"
            //                         ]
            //                     ];

            //                     for (let i = 0; i < selectList.length; i++) {
            //                             var row = [];
            //                             row.push(selectList[i].companyNameCN);
            //                             row.push(selectList[i].companyScoreRaw);
            //                             row.push(selectList[i].classCount);
            //                             row.push(selectList[i].companyScoreAd);
            //                             row.push(selectList[i].companyScoreRawRank);
            //                             row.push(selectList[i].eqalloccompanyScoreRaw);
            //                             row.push(selectList[i].eqallocclassCount);
            //                             row.push(selectList[i].eqalloccompanyScoreAd);
            //                             row.push(selectList[i].eqalloccompanyScoreRawRank);
            //                             row.push(selectList[i].fxinccompanyScoreRaw);
            //                             row.push(selectList[i].fxincclassCount);
            //                             row.push(selectList[i].fxinccompanyScoreAd);
            //                             row.push(selectList[i].fxinccompanyScoreRawRank);
            //                             row.push(selectList[i].fundSize);
            //                             row.push(selectList[i].fundSizeRank);
            //                             row.push(selectList[i].fundCount);
            //                             row.push(selectList[i].fundCountRank);
            //                             row.push(selectList[i].fundSizeFlow_1Y);
            //                             row.push(selectList[i].fundSizeFlowRank_1Y);
            //                             row.push(selectList[i].fundSizeFlowPer_1Y);
            //                             row.push(selectList[i].fundSizeFlowPerRank_1Y);
            //                             row.push(selectList[i].fundSizeFlow_3Y);
            //                             row.push(
            //                                 selectList[i].fundSizeFlowRank_3Y
            //                             );
            //                             row.push(selectList[i].fundSizeFlowPer_3Y);
            //                             row.push(
            //                                 selectList[i].fundSizeFlowPerRank_3Y
            //                             );
            //                             row.push(selectList[i].equity);
            //                             row.push(
            //                                 selectList[i].equityrank
            //                             );
            //                             row.push(selectList[i].fxinc);
            //                             row.push(
            //                                 selectList[i].fxincrank
            //                             );
            //                             row.push(selectList[i].alloc);
            //                             row.push(
            //                                 selectList[i].allocrank
            //                             );
            //                             row.push(selectList[i].mnmkt);
            //                             row.push(
            //                                 selectList[i].mnmktrank
            //                             );
            //                             row.push(
            //                                 selectList[i].other
            //                             );
            //                             row.push(selectList[i].star1Per);
            //                             row.push(
            //                                 selectList[i].star2Per
            //                             );
            //                             row.push(
            //                                 selectList[i].star3Per
            //                             );
            //                             row.push(selectList[i].star4Per);
            //                             row.push(
            //                                 selectList[i].star5Per
            //                             );
            //                             row.push(
            //                                 selectList[i].aumweightedStar
            //                             );
            //                             row.push(selectList[i].managerCount);
            //                             row.push(
            //                                 selectList[i].managerCountRank
            //                             );
            //                             row.push(
            //                                 selectList[i].managerCareerTime
            //                             );
            //                             row.push(selectList[i].managerCareerTimeRank);
            //                             row.push(
            //                                 selectList[i].managerStayTime
            //                             );
            //                             row.push(
            //                                 selectList[i].managerStayTimeRank
            //                             );
            //                             row.push(selectList[i].retention_3Y);
            //                             row.push(
            //                                 selectList[i].retentionRank_3Y
            //                             );
            //                             row.push(
            //                                 selectList[i].terscore
            //                             );
            //                             row.push(
            //                                 selectList[i].terscoreRank
            //                             );
            //                             exportData.push(row);
            //                         }
            //                 }
            //                 var dataSheet = XLSX.utils.aoa_to_sheet(
            //                     exportData
            //                 );
            //                 openDownloadDialog(
            //                     sheet2blob4Rank(
            //                         XLSX,
            //                         dataSheet,
            //                         "数据"
            //                     ),
            //                     fileName + ".xlsx"
            //                 );
            //             }
            //         }
            //     }
            // })
            // .catch(err => {
            //     Message({
            //         message: "数据异常，请尝试刷新再试！",
            //         type: "error",
            //         duration: 2 * 1000
            //     });
            //     Message.close = function() {};
            // })
            // .finally(r => {
            //     self.loading = false;
            // });
        },
        getRatingDate(ratingYear, ratingMonth) {
            let strDate = ratingYear + "-" + ratingMonth;
            let date = new Date(strDate);
            let nDate = new Date(date.setMonth(date.getMonth() + 1));
            return new Date(
                nDate.setDate(nDate.getDate() - 1)
            ).toLocaleDateString();
        },
        getWorkDateFun(param) {
            const self = this;
            getWorkDate(param)
                .then(response => {
                    let result = response.data;
                    if (result == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000
                        });
                        Message.close = function () { };
                    } else {
                        if (checkResponseStatus(result, self)) {
                            if (
                                Number(result._meta.response_status) === 200032
                            ) {
                                Message({
                                    message:
                                        "非常抱歉，数据正在更新中，请稍后再试！",
                                    type: "warning",
                                    duration: 3 * 1000
                                });
                                Message.close = function () { };
                            } else {
                                let data = response.data.data;
                                if (
                                    response.data &&
                                    response.data.data &&
                                    response.data.data.length > 0
                                ) {
                                    self.dateValue = response.data.data[0];
                                    window.latestWorkDate =
                                        response.data.data[0];
                                    window.availableWorkDate =
                                        response.data.data;
                                }
                            }
                        }
                    }
                })
                .catch(err => {
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000
                    });
                    Message.close = function () { };
                })
                .finally(r => {
                    self.loading = false;
                });
        },
        setDateValueMonthlyToLastMonthendDateWhenItIsNull() {
            if (
                this.dateValueMonthly == null ||
                this.dateValueMonthly == "" ||
                this.dateValueMonthly == undefined
            ) {
                let newDate = new Date();
                let lastMonthEndDate = new Date(
                    newDate.getFullYear(),
                    newDate.getMonth(),
                    0
                );
                //this.dateValueMonthly = lastMonthEndDate.getFullYear() +"-"+(lastMonthEndDate.getMonth() + 1).toString().padStart(2,'0')+"-"+lastMonthEndDate.getDate();
                this.dateValueMonthly =
                    lastMonthEndDate.getFullYear() +
                    "-" +
                    (lastMonthEndDate.getMonth() + 1)
                        .toString()
                        .padStart(2, "0");
            }
        },
        openAlert() {
            this.$alert(
                "部分特殊类型基金业绩更新延迟，最终排名或有微调，如需即时引用请注明引用时间。",
                "提醒",
                {
                    confirmButtonText: "确定"
                }
            );
        },
        formatDate(date) {
            if (date.indexOf("00:00:00.0") > -1) {
                date = date.replace(" 00:00:00.0", "");
            } else {
                date = new Date(date).format("yyyy/MM/dd");
            }
            return date;
        },
        monthlyRankSignOff() {
            const self = this;
            if (self.showMonthlyRankingDate && !self.monthlySignOff) {
                return false;
            }
            return true;
        },
        savaSubscritionInfo() {
            const self = this;
            self.configSendDialogVisible = false;
            self.dialogLoading = true;
            let params = {
                subscription: self.emailsParagraph
            };
            if (self.showDailylyRankingDate) {
                params.type = 1;
                params.frequency = self.selectFrequencyDaily;
            } else {
                params.type = 2;
                params.frequency = self.selectFrequencyMonthly;
            }
            self.editConfig(params);
        }
    }
};

Date.prototype.format = function (fmt) {
    var o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours() % 12 == 0 ? 12 : this.getHours() % 12, //小时
        "H+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        S: this.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(
            RegExp.$1,
            (this.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(
                RegExp.$1,
                RegExp.$1.length == 1
                    ? o[k]
                    : ("00" + o[k]).substr(("" + o[k]).length)
            );
    return fmt;
};
</script>
<style lang="scss">
@import "../../public/sass/components/ranking";

.red span {
    border: 1px solid red;
    border-radius: 50%;
}

#elselectFundOrCompany.el-input__inner {
    width: 100px !important;
    margin-right: -10px !important;
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
}

#elselectCompany.el-input__inner,
#elselectFund.el-input__inner {
    border-top-left-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
    margin-top: -10px;
}

.tableTitle {
    position: relative;
    margin: 0 auto;
    width: 900px;
    height: 1px;
    background-color: #d4d4d4;
    text-align: center;
    font-size: 16px;
    color: rgba(101, 101, 101, 1);
    margin-left: 1px;
    margin-top: 24px;
}

.midText {
    position: absolute;
    left: 50%;
    background-color: #ffffff;
    padding: 0 15px;
    transform: translateX(-50%) translateY(-50%);
}

.imgs_logo {
    height: 25px;
    width: 100px;
    margin-top: -3%;
    margin-left: 69%;
    background: url("../../public/images/logo_image.png") no-repeat;
}

// .el-popover__reference{margin-left: 1000px;margin-top: -15px;}</style>